import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types/cashFlow';
import {
  CashFlowExpenseSalaryDetailItem,
  CashFlowExpenseSalaryItem,
  CashFlowExpenseSalaryRequest,
  CashFlowExpenseSalaryRequestAutoFill,
} from '../types/cashFlowExpenseSalary';

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowExpenseSalary: builder.query<CashFlowExpenseSalaryItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.id}`,
      }),
    }),
    changeCashFlowExpenseSalary: builder.mutation<void, PayloadRequest & CashFlowExpenseSalaryItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createCashFlowExpenseSalary: builder.mutation<void, CashFlowExpenseSalaryItem>({
      query: (data) => ({
        url: '/v1/CashFlowExpenseSalary',
        method: 'POST',
        body: data,
      }),
    }),

    getCashFlowExpenseSalaryDetailList: builder.query<CashFlowExpenseSalaryDetailItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.id}/details`,
      }),
    }),
    getCashFlowExpenseSalaryDetail: builder.query<CashFlowExpenseSalaryDetailItem, CashFlowExpenseSalaryRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/details/${data.detailId}`,
      }),
    }),
    changeCashFlowExpenseSalaryDetail: builder.mutation<void, CashFlowExpenseSalaryDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/details/${data.detailId}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createCashFlowExpenseSalaryDetail: builder.mutation<void, CashFlowExpenseSalaryDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
    deleteCashFlowExpenseSalaryDetail: builder.mutation<void, CashFlowExpenseSalaryRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/details/${data.detailId}`,
        method: 'DELETE',
      }),
    }),
    changeCashFlowExpenseSalaryDetailIssued: builder.mutation<void, CashFlowExpenseSalaryRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/details/${data.detailId}/issued`,
        method: 'PUT',
      }),
    }),
    cashFlowExpenseSalaryDetailAutofill: builder.mutation<void, CashFlowExpenseSalaryRequestAutoFill>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseSalary/${data.cashFlowId}/autofill`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useChangeCashFlowExpenseSalaryMutation,
  useCreateCashFlowExpenseSalaryMutation,
  useGetCashFlowExpenseSalaryQuery,
  useLazyGetCashFlowExpenseSalaryQuery,

  useGetCashFlowExpenseSalaryDetailListQuery,
  useGetCashFlowExpenseSalaryDetailQuery,
  useLazyGetCashFlowExpenseSalaryDetailQuery,
  useDeleteCashFlowExpenseSalaryDetailMutation,
  useCreateCashFlowExpenseSalaryDetailMutation,
  useChangeCashFlowExpenseSalaryDetailMutation,
  useCashFlowExpenseSalaryDetailAutofillMutation,
  useChangeCashFlowExpenseSalaryDetailIssuedMutation,
} = cashFlowSchemas;
